// import React, { useState, useEffect } from 'react';
// import { TextField, MenuItem, Stack, Box } from '@mui/material';
// import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs from 'dayjs';

// export default function CustomDateTimePicker({
//     bufferingTime = 0,
//     value,
//     setDateValue,
//     minDateTime = new Date(),
// }) {




//     const [date, setDate] = useState(dayjs());
//     const [hour, setHour] = useState('12');
//     const [minute, setMinute] = useState('00');
//     const [period, setPeriod] = useState('AM');
//     const [error, setError] = useState('');

//     const now = dayjs();

//     const isToday = date && dayjs(date).isSame(now, 'day');

//     const hours = [...Array(12)].map((_, i) => String(i + 1).padStart(2, '0'));
//     const minutes = [...Array(60)].map((_, i) => String(i).padStart(2, '0'));

//     // Sync from prop when value changes
//     useEffect(() => {
//         if (value) {
//             const parsed = dayjs(value, 'YYYY-MM-DD hh:mm:ss A');
//             if (parsed.isValid()) {
//                 setDate(parsed);
//                 let hr = parsed.hour();
//                 const min = parsed.minute().toString().padStart(2, '0');
//                 const ampm = hr >= 12 ? 'PM' : 'AM';
//                 hr = hr % 12 === 0 ? 12 : hr % 12;
//                 const hrStr = hr.toString().padStart(2, '0');

//                 setHour(hrStr);
//                 setMinute(min);
//                 setPeriod(ampm);
//             }
//         }
//     }, [value]);

//     const updateDateTime = (d, h, m, p) => {
//         if (!d) return;

//         const hourInt = parseInt(h, 10);
//         const minuteInt = parseInt(m, 10);
//         const isPM = p === 'PM';
//         const finalHour = isPM && hourInt !== 12 ? hourInt + 12 : (!isPM && hourInt === 12 ? 0 : hourInt);

//         const updated = dayjs(d).hour(finalHour).minute(minuteInt).second(0);

//         if (minDateTime && updated.isBefore(dayjs(minDateTime))) {
//             setError(`Pickup time must be at least ${bufferingTime} minutes ahead of the current time.`);
//             return;
//         }

//         setDate(updated);
//         setDateValue(updated);
//         setError('');
//     };

//     const handleTimeChange = (field, value) => {
//         const newHour = field === 'hour' ? value : hour;
//         const newMinute = field === 'minute' ? value : minute;
//         const newPeriod = field === 'period' ? value : period;

//         if (field === 'hour') setHour(value);
//         if (field === 'minute') setMinute(value);
//         if (field === 'period') setPeriod(value);

//         updateDateTime(date, newHour, newMinute, newPeriod);
//     };

//     // Disable logic
//     //   const isHourDisabled = (h) => {

//     //     if (!date.isSame(now, 'day')) return false;

//     //     let hr = parseInt(h, 10);
//     //     const finalHour = period === 'PM' ? (hr !== 12 ? hr + 12 : 12) : hr === 12 ? 0 : hr;


//     //     console.log("finalHour",h);

//     //     return finalHour < h;
//     //   };

//     const isHourDisabled = (optionHour) => {
//         if (!isToday) return false;

//         let hr = parseInt(optionHour, 10);
//         let hour24 =
//             period === 'PM'
//                 ? (hr !== 12 ? hr + 12 : 12)
//                 : hr === 12
//                     ? 0
//                     : hr;

//         return hour24 < now.hour();
//     };



//     const isMinuteDisabled = (optionMinute) => {
//         if (!isToday) return false;

//         let hr = parseInt(hour, 10);
//         let hour24 =
//             period === 'PM'
//                 ? (hr !== 12 ? hr + 12 : 12)
//                 : hr === 12
//                     ? 0
//                     : hr;

//         if (hour24 !== now.hour()) return false;

//         return parseInt(optionMinute, 10) < now.minute();
//     };


//     const isPeriodDisabled = (p) => {
//         if (!isToday) return false;

//         if (p === 'AM' && now.hour() >= 12) return true;
//         return false;
//     };


//     return (
//         <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <Stack spacing={2}>
//                 <DatePicker
//                     label="Select Date"
//                     value={date}
//                     minDate={dayjs(minDateTime)}
//                     onChange={(newVal) => {
//                         if (newVal) updateDateTime(newVal, hour, minute, period);
//                     }}
//                     renderInput={(params) => <TextField {...params} fullWidth size="small" />}
//                     inputFormat="DD/MM/YYYY"
//                 />

//                 <Stack direction="row" spacing={2}>
//                     <TextField
//                         select
//                         label="Hour"
//                         value={hour}
//                         onChange={(e) => handleTimeChange('hour', e.target.value)}
//                         sx={{ minWidth: 100 }}
//                         size="small"
//                     >
//                         {hours.map((h) => (
//                             <MenuItem key={h} value={h} disabled={isHourDisabled(h)}>
//                                 {h}
//                             </MenuItem>

//                         ))}

//                     </TextField>

//                     <TextField
//                         select
//                         label="Minute"
//                         value={minute}
//                         onChange={(e) => handleTimeChange('minute', e.target.value)}
//                         sx={{ minWidth: 100 }}
//                         size="small"
//                     >
//                         {minutes.map((m) => (
//                             <MenuItem
//                                 key={m}
//                                 value={m}
//                                 disabled={isMinuteDisabled(m)}
//                             >
//                                 {m}
//                             </MenuItem>
//                         ))}

//                     </TextField>

//                     <TextField
//                         select
//                         label="AM/PM"
//                         value={period}
//                         onChange={(e) => handleTimeChange('period', e.target.value)}
//                         sx={{ minWidth: 100 }}
//                         size="small"
//                     >
//                         {['AM', 'PM'].map((p) => (
//                             <MenuItem key={p} value={p} disabled={isPeriodDisabled(p)}>
//                                 {p}
//                             </MenuItem>
//                         ))}
//                     </TextField>
//                 </Stack>

//                 {error && (
//                     <Box sx={{ color: 'red', fontSize: 14 }}>{error}</Box>
//                 )}
//             </Stack>
//         </LocalizationProvider>
//     );
// }


import React, { useState, useEffect } from 'react';
import { TextField, MenuItem, Stack, Box } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

export default function CustomDateTimePicker({
    bufferingTime = 0,
    value,
    setDateValue,
    minDateTime = new Date(),
}) {




    const [date, setDate] = useState(dayjs());
    const [hour, setHour] = useState('12');
    const [minute, setMinute] = useState('00');
    const [period, setPeriod] = useState('AM');
    const [error, setError] = useState('');

    const now = dayjs();

    const isToday = date && dayjs(date).isSame(now, 'day');

    const minTime = dayjs(minDateTime);
    const isSameMinDay = date && dayjs(date).isSame(minTime, 'day');


    const hours = [...Array(12)].map((_, i) => String(i + 1).padStart(2, '0'));
    const minutes = [...Array(60)].map((_, i) => String(i).padStart(2, '0'));

    // Sync from prop when value changes
    useEffect(() => {
        if (value) {
            const parsed = dayjs(value, 'YYYY-MM-DD hh:mm:ss A');
            if (parsed.isValid()) {
                setDate(parsed);
                let hr = parsed.hour();
                const min = parsed.minute().toString().padStart(2, '0');
                const ampm = hr >= 12 ? 'PM' : 'AM';
                hr = hr % 12 === 0 ? 12 : hr % 12;
                const hrStr = hr.toString().padStart(2, '0');

                setHour(hrStr);
                setMinute(min);
                setPeriod(ampm);
            }
        }
    }, [value]);

    const updateDateTime = (d, h, m, p) => {
        if (!d) return;

        const hourInt = parseInt(h, 10);
        const minuteInt = parseInt(m, 10);

        const finalHour =
            p === 'PM'
                ? hourInt === 12 ? 12 : hourInt + 12
                : hourInt === 12 ? 0 : hourInt;

        let updated = dayjs(d)
            .startOf('day')
            .hour(finalHour)
            .minute(minuteInt)
            .second(0);

        // 🔒 HARD CLAMP (absolute rule)
        if (updated.isBefore(minTime)) {
            updated = minTime;
        }

        setDate(updated);
        setHour(updated.format('hh'));
        setMinute(updated.format('mm'));
        setPeriod(updated.format('A'));
        setDateValue(updated);
        setError('');
    };


    const handleTimeChange = (field, value) => {
        const newHour = field === 'hour' ? value : hour;
        const newMinute = field === 'minute' ? value : minute;
        const newPeriod = field === 'period' ? value : period;

        if (field === 'hour') setHour(value);
        if (field === 'minute') setMinute(value);
        if (field === 'period') setPeriod(value);

        updateDateTime(date, newHour, newMinute, newPeriod);
    };

    // Disable logic
    //   const isHourDisabled = (h) => {

    //     if (!date.isSame(now, 'day')) return false;

    //     let hr = parseInt(h, 10);
    //     const finalHour = period === 'PM' ? (hr !== 12 ? hr + 12 : 12) : hr === 12 ? 0 : hr;


    //     console.log("finalHour",h);

    //     return finalHour < h;
    //   };

    const to24Hour = (h, p) => {
        const hr = parseInt(h, 10);
        if (p === 'PM') return hr === 12 ? 12 : hr + 12;
        return hr === 12 ? 0 : hr;
    };

    const baseDate = dayjs(date).startOf('day');


    const isHourDisabled = (optionHour) => {
        if (!isSameMinDay) return false;

        const hour24 = to24Hour(optionHour, period);

        const simulated = baseDate
            .hour(hour24)
            .minute(parseInt(minute, 10))
            .second(0);

        return simulated.isBefore(minTime);
    };





    const isMinuteDisabled = (optionMinute) => {
        if (!isSameMinDay) return false;

        const hour24 = to24Hour(hour, period);

        const simulated = baseDate
            .hour(hour24)
            .minute(parseInt(optionMinute, 10))
            .second(0);

        return simulated.isBefore(minTime);
    };



    const isPeriodDisabled = (p) => {
        if (!isSameMinDay) return false;

        const hour24 = to24Hour(hour, p);

        const simulated = baseDate
            .hour(hour24)
            .minute(parseInt(minute, 10))
            .second(0);

        return simulated.isBefore(minTime);
    };



    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack spacing={2}>
                <DatePicker
                    label="Select Date"
                    value={date}
                    minDate={dayjs(minDateTime)}
                    onChange={(newVal) => {
                        if (newVal) updateDateTime(newVal, hour, minute, period);
                    }}
                    renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                    inputFormat="DD/MM/YYYY"
                />

                <Stack direction="row" spacing={2}>
                    <TextField
                        select
                        label="Hour"
                        value={hour}
                        onChange={(e) => handleTimeChange('hour', e.target.value)}
                        sx={{ minWidth: 100 }}
                        size="small"
                    >
                        {hours.map((h) => (
                            <MenuItem key={h} value={h} disabled={isHourDisabled(h)}>
                                {h}
                            </MenuItem>

                        ))}

                    </TextField>

                    <TextField
                        select
                        label="Minute"
                        value={minute}
                        onChange={(e) => handleTimeChange('minute', e.target.value)}
                        sx={{ minWidth: 100 }}
                        size="small"
                    >
                        {minutes.map((m) => (
                            <MenuItem
                                key={m}
                                value={m}
                                disabled={isMinuteDisabled(m)}
                            >
                                {m}
                            </MenuItem>
                        ))}

                    </TextField>

                    <TextField
                        select
                        label="AM/PM"
                        value={period}
                        onChange={(e) => handleTimeChange('period', e.target.value)}
                        sx={{ minWidth: 100 }}
                        size="small"
                    >
                        {['AM', 'PM'].map((p) => (
                            <MenuItem key={p} value={p} disabled={isPeriodDisabled(p)}>
                                {p}
                            </MenuItem>
                        ))}
                    </TextField>
                </Stack>

                {error && (
                    <Box sx={{ color: 'red', fontSize: 14 }}>{error}</Box>
                )}
            </Stack>
        </LocalizationProvider>
    );
}
